import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Suppress HMR logs
const originalConsoleLog = console.log;
console.log = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('[HMR]')) {
    return;
  }
  originalConsoleLog.apply(console, args);
};

if (environment.hmr) {
  if (module['hot']) {
    module['hot'].accept();
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
